import { useAppDispatch, useAppSelector } from '@app/hooks';
import { useEffect } from 'react';
import _ from 'lodash';
import { getAllBrands } from '@app/store/brandName/reducer';

export const useBrandName = (): void => {
    const { isFetching, lastUpdated, brands } = useAppSelector(
        (state) => state.brandName
    );
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isFetching && brands.length === 0 && !lastUpdated) {
            dispatch(getAllBrands());
        }
    }, []);
};
